import { currencyMap, POSITION_AFTER } from "src/utils/currencySymbols";

const getCurrency = (language: string): string => {
  return currencyMap[language].position === POSITION_AFTER
    ? `${currencyMap[language].code} ${currencyMap[language].symbol}`
    : `${currencyMap[language].symbol} ${currencyMap[language].code}`;
};

export default getCurrency;
